import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IColumn, ISortingObject, SortingTypes } from 'components/Table/types';

const tableSlice = createSlice({
  name: 'table',
  initialState: {
    list: [],
    sorting: { field: 'id', order: SortingTypes.ASC },
    page: 0,
    rowsPerPage: 20,
    totalCount: 0,
    columnsWithoutWidth: 0,
    columns: [] as IColumn[],
    tableBodyWidth: 0,
    filtering: {},
  },
  reducers: {
    saveList: (state, action) => {
      state.list = action.payload;
    },
    setSortingObject: (state, action: PayloadAction<ISortingObject>) => {
      state.sorting = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    },
    setColumnsWithoutWidth: (state, action: PayloadAction<number>) => {
      state.columnsWithoutWidth = action.payload;
    },
    setColumns: (state, action: PayloadAction<IColumn[]>) => {
      state.columns = action.payload;
    },
    setTableBodyWidth: (state, action: PayloadAction<number>) => {
      state.tableBodyWidth = action.payload;
    },
    setFiltering: (state, action: PayloadAction<{ field: string; value: string }>) => {
      state.filtering = {
        ...state.filtering,
        [action.payload.field]: action.payload.value,
      };
    },
  },
});

export default tableSlice.reducer;

export const {
  setColumnsWithoutWidth,
  setTotalCount,
  saveList,
  setSortingObject,
  setRowsPerPage,
  setPage,
  setColumns,
  setTableBodyWidth,
  setFiltering,
} = tableSlice.actions;
